"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgStar(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("path", { d: "M17.56 21a1 1 0 01-.46-.11L12 18.22l-5.1 2.67a1 1 0 01-1.45-1.06l1-5.63-4.12-4a1 1 0 01-.25-1 1 1 0 01.81-.68l5.7-.83 2.51-5.13a1 1 0 011.8 0l2.54 5.12 5.7.83a1 1 0 01.81.68 1 1 0 01-.25 1l-4.12 4 1 5.63a1 1 0 01-.4 1 1 1 0 01-.62.18z", "data-name": "star" }))));
}
exports["default"] = React.forwardRef(SvgStar);
//# sourceMappingURL=Star.js.map